module.exports = __webpack_public_path__ + "static/window-4632c84e39757e84676e5487b58a91c3.png";